import React, { useLayoutEffect, useEffect } from 'react';
import { BackHandler } from 'react-native';
import { HeaderBackButton } from '@react-navigation/elements';
import { Color } from '../styles';

//custom hook to ensure MyTripsScreen is not reloaded
export function useBackButtonEffect(navigation, screen, props) {
  const backAction = () => {
    navigation.navigate(screen, { ...props });
    return true;
  };

  //Back arrow button at the top of the screen
  useLayoutEffect(() => {
    navigation.setOptions({
      headerLeft: () => <HeaderBackButton tintColor={Color.primary} onPress={backAction} />,
    });
  }, []);

  //Back button from mobile
  useEffect(() => {
    BackHandler.addEventListener('hardwareBackPress', backAction);
    return () => BackHandler.removeEventListener('hardwareBackPress', true);
  }, []);
}
